module.exports = __webpack_public_path__ + "img/map-pickup.d8225f2b.jpg";